export class Location {
    value:number;
    label:string;


    constructor(locationResponse:any){
        this.value = locationResponse.id;
        this.label = locationResponse.display_name;
    }
} 